import { useRouterState } from "@tanstack/react-router";
import { useDebounce } from "~/hooks/use-debounce";
import { cn } from "~/lib/utils";

export function TransitionLoader() {
  const showLoader = useRouterState({
    select: (state) => state.isLoading || state.isTransitioning,
  });
  const animateLoader = useDebounce(showLoader, 75); // <-- Keep in sync...

  return (
    <div
      className={cn(
        "fixed top-0 left-0 w-screen h-[3px] pointer-events-none",
        showLoader
          ? "opacity-100"
          : "opacity-0 transition-opacity duration-[75ms]", // <-- ...with this
      )}
    >
      <div
        className={cn(
          "fixed top-0 left-0 h-[3px] bg-[#924dff]",
          animateLoader ? "animate-loading-bar delay-[-100ms]" : "",
        )}
      ></div>
    </div>
  );
}
